import { render } from "./StyleGuide.vue?vue&type=template&id=cc401bda&hidden=true"
import script from "./StyleGuide.vue?vue&type=script&lang=js"
export * from "./StyleGuide.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jamesedgeworth/Sites/je-vue/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__